import Team from '../views/Team'
import { useStore } from '../state/store'

export const TeamContainer = () => {
  const workspaceId = useStore(state => state.workspace.id) as string
  const organizationId = useStore(state => state.organization.id) as string
  return <Team workspaceId={workspaceId} organizationId={organizationId} />
}
